import BookingState from '@/types/store/booking/BookingState';
import Booking from '@/types/taxcard/Booking';

const storedCurrentBooking = localStorage.getItem('currentBooking');
const storedCurrentBookingSession = localStorage.getItem('currentBookingSession');
const storedCurrentPriceProjection = localStorage.getItem('currentPriceProjection');
const storedCurrentOrderId = localStorage.getItem('currentOrderId');

const state: BookingState = {
  communes: [],
  currentBooking: storedCurrentBooking !== null ? Booking.hydrate(storedCurrentBooking) : null,
  currentBookingSession: storedCurrentBookingSession !== null ? JSON.parse(storedCurrentBookingSession) : null,
  currentPriceProjection: storedCurrentPriceProjection !== null ? JSON.parse(storedCurrentPriceProjection) : null,
  currentOrderId: storedCurrentOrderId !== null ? JSON.parse(storedCurrentOrderId) : null,
  accommodations: [],
  currentPaymentMethod: null,
};

export default state;
